import React from 'react';
import getInitials from '../../utils/getInitials';
import '../../css/common/MemberCard.css';

const MemberCard = ({ name, title, imageUrl, index }) => {
  const [imageFailed, setImageFailed] = React.useState(false);
  const showMonogram = !imageUrl || imageFailed;
  return (
    <div className="member-card-component">
      <div className="member-card-headshot-container">
        {showMonogram ? (
          <div className="member-card-monogram" role="img" aria-label={name}>
            {getInitials(name)}
          </div>
        ) : (
          <img 
            src={imageUrl} 
            alt={name} 
            className="member-card-headshot"
            onError={() => setImageFailed(true)}
          />
        )}
      </div>
      <div className="member-card-content">
        <h3 className="member-card-name">{name}</h3>
        <p className="member-card-title">{title}</p>
      </div>
    </div>
  );
};

export default MemberCard;

